import { create } from 'zustand';
import type { User } from '../types/api';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  /** True once we've done the initial /auth/me probe. */
  bootstrapped: boolean;
  setSession: (user: User, accessToken: string) => void;
  setAccessToken: (token: string | null) => void;
  setBootstrapped: (v: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  bootstrapped: false,
  setSession: (user, accessToken) => set({ user, accessToken }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setBootstrapped: (bootstrapped) => set({ bootstrapped }),
  clear: () => set({ user: null, accessToken: null }),
}));
